import { render, staticRenderFns } from "./ValidacaoQRCode.vue?vue&type=template&id=39174fd6&scoped=true"
import script from "./ValidacaoQRCode.vue?vue&type=script&lang=js"
export * from "./ValidacaoQRCode.vue?vue&type=script&lang=js"
import style0 from "./ValidacaoQRCode.vue?vue&type=style&index=0&id=39174fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39174fd6",
  null
  
)

export default component.exports